import { UPDATE_PURCHASE_MODE } from '../Types';

export const purchaseMode = (state = null, action) => {
  if (action.type === UPDATE_PURCHASE_MODE) {
    return { ...state, ...action.payload };
  }
  return state;
};
